<template>
  <q-menu touch-position
          context-menu
          ref="context">
    <div class="q-pa-sm" style="text-align: center; padding-bottom: 0;">{{(contextItemNoteHelper || {}).name}}</div>
    <q-list link separator no-border
            style="min-width: 150px; max-height: 300px;">
      <q-item clickable v-close-popup @click.native="moveItemTo" v-if="moveFromNoteHelper && moveFromNoteHelper !== contextItemNoteHelper">
        <q-item-section class="text-black">
          {{'Move \'' + moveFromNoteHelper.name + '\' To Here'}}
        </q-item-section>
      </q-item>
      <q-item clickable v-close-popup @click.native="copyItemTo" v-if="moveFromNoteHelper && moveFromNoteHelper !== contextItemNoteHelper">
        <q-item-section>
          {{'Copy \'' + moveFromNoteHelper.name + '\' To Here'}}
        </q-item-section>
      </q-item>
      <q-item clickable v-close-popup @click.native="moveItemFrom">
        <q-item-section>Move/Copy</q-item-section>
      </q-item>
      <q-item v-if="moveFromNoteHelper" v-close-popup @click.native="moveItemToRoot">
        <q-item-section>Move To Top Level</q-item-section>
      </q-item>
      <q-item clickable v-close-popup @click.native="newSubNote()">
        <q-item-section>Add Child</q-item-section>
      </q-item>
      <q-item clickable v-close-popup @click.native="deleteNote()">
        <q-item-section>Delete</q-item-section>
      </q-item>
      <q-item clickable v-close-popup @click.native="setRootNote(itemId)">
        <q-item-section>Set Session Root</q-item-section>
      </q-item>
    </q-list>
  </q-menu>
</template>

<script>
import { deleteNote, navigateToNote, newSubNote } from '../js/noteTemplates/noteUiHelpers'
import { findNoteHelper } from '../js/noteTemplates/noteHelpers'
import { expandNoteIdInTree, updateCurrentSession } from '../js/noteTemplates/sessionsHelper'

export default {
  name: 'NoteContextMenu',
  props: ['itemId'],
  data () {
    return {
      moveFromNoteHelper: null
    }
  },
  computed: {
    contextItemNoteHelper () {
      return findNoteHelper(this.itemId)
    }
  },
  methods: {
    deleteNote () {
      deleteNote(this.itemId)
    },
    newSubNote () {
      newSubNote(this.itemId)
    },
    moveItemFrom () {
      this.moveFromNoteHelper = findNoteHelper(this.itemId)
    },
    moveItemTo () {
      if (!this.moveFromNoteHelper) return
      this.moveFromNoteHelper.parent = this.contextItemNoteHelper
      this.moveFromNoteHelper = null
    },
    async copyItemTo () {
      if (!this.moveFromNoteHelper) return
      const newNoteHelper = await this.moveFromNoteHelper.copyTo(this.contextItemNoteHelper, true)
      await expandNoteIdInTree(this.contextItemNoteHelper.noteId)
      navigateToNote(newNoteHelper.noteId)
      this.moveFromNoteHelper = null
    },
    setRootNote (noteId) {
      return updateCurrentSession({ rootNoteId: noteId })
    }
  }
}
</script>

<style scoped>

</style>
